import { useRef } from "react";
import Cancel from "../../assest/svg/cancel.svg";
import Pause from "../../assest/svg/Pause.svg";
import Clip from "../../assest/svg/clip.svg";
import ClipEngage from "../../assest/svg/clip_engage.svg";
import Send from "../../assest/svg/send.svg";
import FileIcon from "../../assest/svg/file.svg";

type InputProps = {
  onSubmit: (message: string) => void;
  loading: boolean;
  disabled?: boolean;
  setInput: (input: string) => void;
  setImage: (image: File[]) => void;
  input: string;
  image: File[];
  cancelApi: () => void;
  fetching: boolean;
};

export const Input = (data: InputProps) => {
  const { loading, onSubmit, setInput, setImage, input, image, cancelApi, fetching } = data;
  const inputFileRef = useRef<HTMLInputElement | null>(null);

  const handleSend = () => {
      onSubmit(input); // Call parent onSubmit handler
      setInput(""); // Reset input
      setImage([]); // Reset image
  };
  const handleAddImage = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setImage([...(image ?? []), ...Array.from(event.target.files)]);
    }
  };
  const handleRemoveImage = (index: number) => {
    setImage(image.filter((_t, i) => i !== index));
  };
  return (
    <div
      className={`font-[500] m-auto w-full border-2 ${
        image ? "rounded-2xl" : "rounded-full"
      }  border-gray-600/20 dark:bg-zinc-800 dark:text-white bg-white`}
    >
      <div className="flex justify-start items-center ">
        {image &&
          Array.from(image).map((i, index) => {
            console.log(i);

            const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(
              i.type.split('/')[1] ?? ""
            );
            return (
              <div className={` top-2 mx-2 mb-2 group border dark:border-gray-400/20 relative ${isImage?" w-28 h-20 mb-3":''}`}>
                {isImage ? (
                  <img
                    className="w-full h-full rounded-xl"
                    src={URL.createObjectURL(i)}
                    alt=""
                  />
                ) : (
                  <div
                    className="flex items-center justify-start w-40 rounded-lg p-2 bg-gray-100 dark:bg-slate-700 shadow-md"
                    key={index}
                  >
                    <img
                      src={FileIcon}
                      className="w-8 h-8  dark:invert"
                      alt="File"
                    />
                    <p
                      rel="noopener noreferrer"
                      className="dark:text-white text-sm truncate"
                    >
                      {i.name}
                    </p>
                  </div>
                )}

                <img
                  src={Cancel}
                  alt="cancel"
                  onClick={() => handleRemoveImage(index)}
                  className="z-10 absolute -top-2 -right-2 w-5 opacity-0 group-hover:opacity-100 transition-opacity bg-white rounded-full border-[0.5px] border-white"
                />
              </div>
            );
          })}
      </div>
      <div
        className={`flex items-center justify-center gap-2  text-lg  ${
          image ? "rounded-b-2xl" : "rounded-full"
        } w-full`}
      >
        <input
          type="text"
          className="flex-1 px-4 rounded-full w-full focus:outline-none h-12 dark:bg-zinc-800 dark:text-white"
          value={input}
          disabled={loading ? true : false}
          placeholder="Ask your question here"
          onChange={(e) => {
            setInput(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && input) handleSend();
          }}
        />
        <input
          type="file"
          className="p-2 hidden bg-transparent"
          disabled={loading ? true : false}
          onChange={(e) => handleAddImage(e)}
          ref={inputFileRef}
          multiple
          accept=".jpg,.png,.jpeg,.docx,.doc,.ppt,.txt,.csv,.pdf,.pptx,.xlsx,.xls"
        />
        <button
          onClick={() => inputFileRef.current?.click()}
          className={`w-6 h-6 rounded-full opacity-50 disabled:opacity-50`}
        >
          <img
            className={`w-full align-middle h-full dark:invert`}
            src={image.length ? ClipEngage : Clip}
            alt="attach"
          />
        </button>
      {!fetching &&   <button
          className="p-2 text-gray-800 rounded-lg opacity-75 disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={handleSend}
          disabled={Boolean(!input && !image.length)}
        >
          <img className="w-6 max-w-6 dark:invert" src={Send} alt="send" />
        </button>}
       {fetching && <button
          className=" text-gray-800 mr-2  border-2 border-gray-400 opacity-75 rounded-full disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => cancelApi()}
        >
          <img className="w-6 max-w-6 dark:invert " src={Pause} alt="cancel" />
        </button>}
      </div>
    </div>
  );
};
